import { Box, Paper, Skeleton } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  isLoading?: boolean;
  skeletons?: number;
}

export const PageContent: FC<Props> = ({ children, isLoading, skeletons = 2 }: Props): JSX.Element => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '24px',
        border: '1px solid #E9E9E9',
      }}
    >
      <Box display="flex" flexDirection="column" padding="32px" gap="24px">
        {isLoading ? (
          <>
            {Array.from({ length: skeletons }).map((_, index) => (
              <Skeleton key={index} variant="rounded" width="100%" height={120} />
            ))}
          </>
        ) : (
          children
        )}
      </Box>
    </Paper>
  );
};
